/* eslint-disable prettier/prettier */
export const FETCH_REPORT_INDEX_LOADING          = 'FETCH_REPORT_INDEX_LOADING';
export const FETCH_REPORT_INDEX_SUCCESS          = 'FETCH_REPORT_INDEX_SUCCESS';
export const FETCH_REPORT_INDEX_ERROR            = 'FETCH_REPORT_INDEX_ERROR';

export const RUN_REPORT_LOADING          = 'RUN_REPORT_LOADING';
export const RUN_REPORT_SUCCESS          = 'RUN_REPORT_SUCCESS';
export const RUN_REPORT_ERROR            = 'RUN_REPORT_ERROR';
